import React, { useCallback, useMemo } from 'react';

import { IPairWallet } from 'api/apiPairs/models';
import { IDexPair } from 'types/pairs';

import { PairTableConnectedBotsHead } from './PairTableConnectedBotsHead';

interface IConnectedBotsHeadProps {
  meta: any;
  dexPair: IDexPair;
}

const ConnectedBotsHead: React.FC<IConnectedBotsHeadProps> = React.memo(({ meta, dexPair }) => {
  const _meta = useMemo(() => meta, [meta]);
  const isActive = useMemo(() => _meta.selectedWallets.length !== 0, [_meta]);

  const { records, setRecords } = _meta;

  const changeWallets = useCallback(
    (newSelectedRecords: IPairWallet[]) => {
      const newRecords = [...records].map(el => {
        const selectedRecord = newSelectedRecords.find(
          selectedRecord => selectedRecord.id === el.id,
        );

        if (selectedRecord) return selectedRecord;

        return el;
      });

      setRecords(newRecords);
    },
    [records, setRecords],
  );

  return (
    <PairTableConnectedBotsHead
      isActive={isActive}
      selectedWallets={_meta.selectedWallets}
      pair={dexPair}
      onChangeSelectedWallets={changeWallets}
    />
  );
});

export default ConnectedBotsHead;
